var React = require('react');

function Kebab (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"SYMBOLS","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"uti/icon/more-vert","transform":"translate(-10.000000, -4.000000)","fill":"#4F4F4F"},React.createElement("g",{"id":"Group","transform":"translate(10.000000, 4.000000)"},[React.createElement("path",{"d":"M2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4 L2,4 Z","id":"Path","key":0}),React.createElement("path",{"d":"M2,6 C0.9,6 0,6.9 0,8 C0,9.1 0.9,10 2,10 C3.1,10 4,9.1 4,8 C4,6.9 3.1,6 2,6 L2,6 Z","id":"Path","key":1}),React.createElement("path",{"d":"M2,12 C0.9,12 0,12.9 0,14 C0,15.1 0.9,16 2,16 C3.1,16 4,15.1 4,14 C4,12.9 3.1,12 2,12 L2,12 Z","id":"Path","key":2})]))));
}

Kebab.defaultProps = {"width":"4px","height":"16px","viewBox":"0 0 4 16","version":"1.1"};

module.exports = Kebab;

Kebab.default = Kebab;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/common/svg/icons/kebab.svg
// module id = 1493
// module chunks = 0